import {
  Pagination,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  Radio,
  RadioButton,
  RadioGroup,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Select,
  Option,
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  DatePicker,
  TimeSelect,
  TimePicker,
  Popover,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Icon,
  Row,
  Col,
  Collapse,
  CollapseItem,
  Badge,
  Cascader,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Loading,
  MessageBox,
  Message,
  Notification
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

const components = [
  Pagination,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  Radio,
  RadioButton,
  RadioGroup,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Select,
  Option,
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  DatePicker,
  TimeSelect,
  TimePicker,
  Popover,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Icon,
  Row,
  Col,
  Collapse,
  CollapseItem,
  Badge,
  Cascader,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Loading
]

const UseElmentUI = (Vue) => {
  if (Vue.prototype.$utils.isApp()) {
    return
  }
  Vue.prototype.$ELEMENT = {
    size: 'small',
    zIndex: 3000,
    elementLoadingSpinner: 'el-icon-loading'
  };
  for (var i = 0, len = components.length; i < len; i++) {
    Vue.use(components[i])
  }
  Vue.prototype.$loading = Loading.service;
  Vue.prototype.$msgbox = MessageBox;
  Vue.prototype.$alert = MessageBox.alert;
  Vue.prototype.$confirm = MessageBox.confirm;
  Vue.prototype.$prompt = MessageBox.prompt;
  Vue.prototype.$message = Message;
  Vue.prototype.$notify = (options) => {
    // options.title
    // options.message
    // options.type success/warning/info/error
    // Notification
    let {
      title = '',
        message = '',
        customClass = '',
        iconClass,
        type,
        showClose = true,
        ...otherOptions
    } = options
    if (!title || !message) {
      customClass += ' el-notification__oneline';
      title += message;
      message = ''
    }
    if (!iconClass) {
      switch (type) {
        case 'success':
          iconClass = 'el-icon-circle-check el-notification__success';
          break;
        case 'error':
          iconClass = 'el-icon-circle-close el-notification__error';
          break;
        case 'warning':
          iconClass = 'el-icon-warning el-notification__warning';
          break;
        case 'info':
          iconClass = 'el-icon-info el-notification__info';
          break;
      }
    }
    let htmlMessage = `<div class='el-notification__content__define ${customClass}'>
        ${
          iconClass ? `<div class ='el-notification__icon ${iconClass}'></div>`:''
        }
        <div class='el-notification__message'>
          <div class = 'el-notification__message__title'>${title}</div>
           ${
             message ? `<div class = 'el-notification__message__text'>${message}</div>` : ''
           }
        </div>
        ${
          showClose ? "<div class='el-notification__message__close'>知道了</div>" : ''
        }
    </div>`
    return Notification({
      message: htmlMessage,
      dangerouslyUseHTMLString: true,
      showClose: true,
      customClass: 'el-notification__define',
      ...otherOptions
    })
  };
}
export default UseElmentUI



// WEBPACK FOOTER //
// ./src/ElmentUI/index.js